export enum Table {
    i18n = 'i18n',
    USER = 'USER'
}